import { Component, OnInit, OnDestroy } from '@angular/core';

interface Produto {
  id: string;
  nome: string;
  tagline: string;
  descricao: string;
  features: string[];
  cor: string;
  corRgb: string;
  gradiente: string;
}

@Component({
  selector: 'app-solucao',
  templateUrl: './solucao.component.html',
  styleUrls: ['./solucao.component.scss']
})
export class SolucaoComponent implements OnInit, OnDestroy {

  produtos: Produto[] = [
    {
      id: 'integra',
      nome: 'IntegraMister',
      tagline: 'Conexão Inteligente',
      descricao: 'Conecte automaticamente seus Bancos ao Mister, eliminando o trabalho manual de importação de extratos e comprovantes. Extratos e documentos chegam prontos para lançamento.',
      features: [
        'Integração com mais de 24 Bancos',
        'Importação automática dos Extratos e Comprovantes',
        'Sincronização em tempo real',
        'Zero retrabalho manual'
      ],
      cor: '#4f8ef7',
      corRgb: '79, 142, 247',
      gradiente: 'linear-gradient(135deg, #6d28d9, #4f8ef7)'
    },
    {
      id: 'neo',
      nome: 'NeoMister',
      tagline: 'Associação automática de lançamentos',
      descricao: 'Geração automática de históricos contábeis perfeitos. Cada lançamento recebe o histórico ideal, preciso e detalhado.',
      features: [
        'Contabilidade precisa e detalhada',
        'Histórico contábil preciso',
        'Aprende com seus padrões',
        'Auditável e rastreável'
      ],
      cor: '#10b981',
      corRgb: '16, 185, 129',
      gradiente: 'linear-gradient(135deg, #059669, #06b6d4)'
    },
    {
      id: 'concilia',
      nome: 'Concilia Cartão',
      tagline: 'Conciliação Automática',
      descricao: 'Conciliação automática de todos os seus lançamentos de cartão de crédito e débito, com rastreabilidade total e integração direta com sua contabilidade.',
      features: [
        'Concilia múltiplas bandeiras',
        'Lançamentos automáticos',
        'Relatório completo',
        'Integração bancária direta'
      ],
      cor: '#f472b6',
      corRgb: '244, 114, 182',
      gradiente: 'linear-gradient(135deg, #db2777, #f59e0b)'
    }
  ];

  selecionado = this.produtos[0];
  saindo = false;
  progresso = 0;

  private progressTimer: any;

  ngOnInit() {
    this.iniciarRotacao();
  }

  ngOnDestroy() {
    clearInterval(this.progressTimer);
  }

  selecionar(produto: Produto) {
    if (this.selecionado.id === produto.id || this.saindo) return;
    this.saindo = true;
    setTimeout(() => {
      this.selecionado = produto;
      this.saindo = false;
      this.progresso = 0;
    }, 220);
    this.resetarRotacao();
  }

  private iniciarRotacao() {
    this.progresso = 0;
    this.progressTimer = setInterval(() => {
      this.progresso += 1;
      if (this.progresso >= 100) {
        const idx = this.produtos.indexOf(this.selecionado);
        this.selecionar(this.produtos[(idx + 1) % this.produtos.length]);
      }
    }, 45);
  }

  private resetarRotacao() {
    clearInterval(this.progressTimer);
    this.iniciarRotacao();
  }
}
